const selectUsisData = (state) => state?.settings?.passportUpload?.usisData;
const selectIsPersDataAutoUpdateEnabled = (state) => selectUsisData(state)?.isPersDataAutoUpdateEnabled;
const selectRedirectToEsiaUrl = (state) => selectUsisData(state)?.redirectToEsiaUrl;
const selectIsModalOpened = (state) => state?.settings?.passportUpload?.isModalOpened;
const selectIsCommonModalOpened = (state) => state?.settings?.passportUpload?.isCommonModalOpened;
const selectMainDataForModalUsis = (state) => selectUsisData(state)?.data;
const selectPassportUploadData = (state) => state?.settings?.passportUpload;
const selectUsisModalStep = (state) => selectPassportUploadData(state)?.usisModalStep;
const selectUsisCommonModalStep = (state) => selectPassportUploadData(state)?.usisCommonModalStep;
const selectCommonModalsData = (state) => selectUsisData(state)?.modals;
const selectIsWaitingRequest = (state) => state?.settings?.passportUpload?.isWaitingRequest;
const selectIsModalConfirmDeactivateOpened = (state) => state?.settings?.passportUpload?.isModalConfirmDeactivateOpened;
const selectIsFetchError = (state) => state?.settings?.passportUpload?.isFetchError;
const selectModalVariant = (state) => selectPassportUploadData(state)?.modalVariant;
const selectEsiaUsisMainParams = (state) => selectMainDataForModalUsis(state)?.mainParams;
const selectEsiaUsisMainParamsOnce = (state) => selectEsiaUsisMainParams(state)?.once;

const selectNotifications = (state) => selectPassportUploadData(state)?.notifications;
const selectHasQueryInUrl = (state) => selectPassportUploadData(state)?.hasQueryInUrl;
const selectIsOnlyOnceVariantUpd = (state) => selectPassportUploadData(state)?.isOnlyOnceVariantUpd;

const selectNotificationDetails = (state) => selectMainDataForModalUsis(state)?.notificationDetails;
const selectPersonalDataRequiredAction = (state) => state?.settings?.passportUpload?.requiredAction;

export {
  selectUsisData,
  selectIsPersDataAutoUpdateEnabled,
  selectIsModalOpened,
  selectMainDataForModalUsis,
  selectUsisModalStep,
  selectPassportUploadData,
  selectCommonModalsData,
  selectIsWaitingRequest,
  selectRedirectToEsiaUrl,
  selectIsModalConfirmDeactivateOpened,
  selectIsFetchError,
  selectModalVariant,
  selectHasQueryInUrl,
  selectIsCommonModalOpened,
  selectUsisCommonModalStep,
  selectNotifications,
  selectNotificationDetails,
  selectIsOnlyOnceVariantUpd,
  selectEsiaUsisMainParams,
  selectEsiaUsisMainParamsOnce,
};
